<div class="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-md mt-6">
    <div class="flex items-center gap-4 mb-8">
        <a routerLink="/admin/term-acceptances" class="text-gray-500 hover:text-gray-700 transition-colors">
            &larr; Voltar
        </a>
        <h2 class="text-3xl font-bold text-gray-800">Detalhes do Aceite de Termo</h2>
    </div>

    <div *ngIf="loading" class="text-center py-12 text-gray-500 text-lg">
        Carregando informações...
    </div>

    <div *ngIf="!loading && item" class="space-y-8">
        <!-- Header Info -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 p-6 bg-gray-50 rounded-lg border border-gray-200">
            <div>
                <label
                    class="block text-sm font-semibold text-gray-500 uppercase tracking-wider mb-1">Fornecedor</label>
                <div class="text-xl font-medium text-gray-900">{{ item.fornecedorNome }}</div>
                <div class="text-sm text-gray-400 font-mono mt-1">{{ item.fornecedorId }}</div>
            </div>
            <div>
                <label class="block text-sm font-semibold text-gray-500 uppercase tracking-wider mb-1">Protocolo
                    Aceite</label>
                <div class="text-xl font-medium text-indigo-600 bg-indigo-50 inline-block px-3 py-1 rounded-md">{{
                    item.protocoloAceite }}</div>
            </div>
        </div>

        <!-- Main Details -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div class="p-6 border border-gray-100 rounded-lg hover:shadow-sm transition-shadow">
                <h3 class="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-500" viewBox="0 0 20 20"
                        fill="currentColor">
                        <path fill-rule="evenodd"
                            d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z"
                            clip-rule="evenodd" />
                    </svg>
                    Dados do Contrato
                </h3>
                <dl class="space-y-3">
                    <div class="flex justify-between border-b border-gray-100 pb-2">
                        <dt class="text-sm text-gray-500">Versão</dt>
                        <dd class="text-sm font-medium text-gray-900">{{ item.versaoContrato }}</dd>
                    </div>
                    <div class="flex justify-between border-b border-gray-100 pb-2">
                        <dt class="text-sm text-gray-500">Data Aceite</dt>
                        <dd class="text-sm font-medium text-gray-900">{{ item.dataAceite | date:'medium' }}</dd>
                    </div>
                </dl>
            </div>

            <div class="p-6 border border-gray-100 rounded-lg hover:shadow-sm transition-shadow">
                <h3 class="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-500" viewBox="0 0 20 20"
                        fill="currentColor">
                        <path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                            clip-rule="evenodd" />
                    </svg>
                    Responsável
                </h3>
                <dl class="space-y-3">
                    <div class="flex justify-between border-b border-gray-100 pb-2">
                        <dt class="text-sm text-gray-500">Usuário ID</dt>
                        <dd class="text-sm font-medium text-gray-900 font-mono">{{ item.usuarioId }}</dd>
                    </div>
                    <div class="flex justify-between border-b border-gray-100 pb-2">
                        <dt class="text-sm text-gray-500">Email</dt>
                        <dd class="text-sm font-medium text-gray-900">{{ item.usuarioEmail }}</dd>
                    </div>
                </dl>
            </div>
        </div>

        <!-- Audit Trail -->
        <div class="bg-gray-900 text-gray-300 p-6 rounded-lg font-mono text-sm shadow-inner">
            <h3 class="text-white text-lg font-semibold mb-4 flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-green-400" viewBox="0 0 20 20"
                    fill="currentColor">
                    <path fill-rule="evenodd"
                        d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clip-rule="evenodd" />
                </svg>
                Audit Trail LGPD
            </h3>
            <div class="grid grid-cols-1 gap-4">
                <div class="border-b border-gray-700 pb-2">
                    <span class="text-gray-500 block mb-1">IP Origem</span>
                    <span class="text-green-400">{{ item.ipOrigem }}</span>
                </div>
                <div class="border-b border-gray-700 pb-2" *ngIf="item.ipForwardedFor">
                    <span class="text-gray-500 block mb-1">X-Forwarded-For</span>
                    <span class="text-white">{{ item.ipForwardedFor }}</span>
                </div>
                <div class="border-b border-gray-700 pb-2 overflow-x-auto" *ngIf="item.userAgent">
                    <span class="text-gray-500 block mb-1">User Agent</span>
                    <span class="text-white whitespace-pre-wrap">{{ item.userAgent }}</span>
                </div>
                <div class="border-b border-gray-700 pb-2 overflow-x-auto" *ngIf="item.hashContrato">
                    <span class="text-gray-500 block mb-1">Hash Contrato</span>
                    <span class="text-yellow-400 break-all">{{ item.hashContrato }}</span>
                </div>
                <div class="border-b border-gray-700 pb-2 overflow-x-auto" *ngIf="item.termoHash">
                    <span class="text-gray-500 block mb-1">Termo Hash</span>
                    <span class="text-yellow-400 break-all">{{ item.termoHash }}</span>
                </div>
            </div>
        </div>
    </div>
</div>